<script setup lang="ts">
import { cn } from '~~/lib/tw-utils'
import { Separator, type SeparatorProps } from 'reka-ui'
import { computed, type HTMLAttributes } from 'vue'

const props = defineProps<SeparatorProps & { class?: HTMLAttributes['class']; label?: string; variant?: 'default' | 'muted' }>()

const delegatedProps = computed(() => {
  const { class: _, variant: __, ...delegated } = props

  return delegated
})

const variantClasses = computed(() => {
  if (props.variant === 'muted') {
    return 'bg-muted'
  }
  return 'bg-border'
})
</script>

<template>
  <Separator
    v-bind="delegatedProps"
    :class="cn('shrink-0 relative', variantClasses, props.orientation === 'vertical' ? 'w-px h-full' : 'h-px w-full', props.class)"
  >
    <span
      v-if="props.label"
      :class="
        cn(
          'text-xs text-muted-foreground bg-background absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex justify-center items-center',
          props.orientation === 'vertical' ? 'w-[1px] px-1 py-2' : 'h-[1px] py-1 px-2',
        )
      "
      >{{ props.label }}</span
    >
  </Separator>
</template>
